export enum BaseStepIdEnum {
  company_search = 'company_search',
  company_list = 'company_list',
  company_edit = 'company_edit',
  individuals_list = 'individuals_list',
  individual_edit = 'individual_edit',
  affiliated_companies_list = 'affiliated_companies_list',
}
